export const serviceListDemoData = [
    {
        id: 3,
        user: {
            id: 49,
            firstName: 'Mir',
            lastName: 'Sayem',
            fullName: 'Mir Sayem',
            organization: 'Pridesys IT',
            primaryEmail: 'pridesys0080@gmail.com',
            primaryPhone: '0155000080',
            demo: true
        },
        productType: 'service',
        subscriptionId: 0,
        applicationId: 1,
        serviceName: 'Installation',
        timeInitiate: 1708580850,
        timeImplement: 1708581538,
        timeOngoing: 1708581549,
        timeDone: 1708581710,
        timeUpdated: 1708581710,
        status: 'completed',
        demo: true
    },
    {
        id: 2,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        subscriptionId: 0,
        applicationId: 2,
        serviceName: 'Backup',
        timeInitiate: 1708573006,
        timeImplement: 1708580518,
        timeOngoing: 1708581026,
        timeDone: 1708582139,
        timeUpdated: 1708582139,
        status: 'completed',
        demo: true
    },
    {
        id: 4,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        subscriptionId: 0,
        applicationId: 2,
        serviceName: 'Backup',
        timeInitiate: 1708583755,
        timeImplement: 1708583769,
        timeOngoing: 1708583897,
        timeDone: 1708583911,
        timeUpdated: 1708583911,
        status: 'completed',
        demo: true
    }
];

export const servicePendingDemoData = [
    {
        invoiceId: 250,
        invoiceItemId: 25,
        user: {
            id: 49,
            firstName: 'Mir',
            lastName: 'Sayem',
            fullName: 'Mir Sayem',
            organization: 'Pridesys IT',
            primaryEmail: 'pridesys0080@gmail.com',
            primaryPhone: '0155000080',
            demo: true
        },
        productType: 'service',
        serviceName: 'Installation',
        packageName: 'Installation',
        subscriptionId: 0,
        applicationId: 1,
        timeUpdated: 1708592924,
        status: 'pending',
        demo: true
    },
    {
        invoiceId: 253,
        invoiceItemId: 38,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        serviceName: 'Migration',
        packageName: 'Migration',
        subscriptionId: 0,
        applicationId: 5,
        timeUpdated: 1708688903,
        status: 'pending',
        demo: true
    },
    {
        invoiceId: 253,
        invoiceItemId: 36,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        serviceName: 'Support Service',
        packageName: 'Support Service',
        subscriptionId: 0,
        applicationId: 6,
        timeUpdated: 1708688903,
        status: 'pending',
        demo: true
    }
];

export const serviceInfoDemoData = {
    serviceInfo: {
        id: 2,
        productType: 'service',
        subscriptionId: 0,
        applicationId: 0,
        serviceName: 'Support',
        packageName: 'Premium Support',
        timeInitiate: 1761955200,
        timeImplement: 0,
        timeOngoing: 0,
        timeDone: 0,
        timeUpdated: 1759654453,
        status: 'initiate',
        timeServiceStart: 1761955200,
        timeServiceEnd: 1793491200
    },
    user: {
        id: 23,
        firstName: 'Bik',
        lastName: '55',
        agencyId: 21,
        fullName: 'Bik 55',
        organization: 'BIK5',
        primaryEmail: 'bik5@bikiran.com',
        primaryPhone: '8801717416667',
        shortCode: 'Bik55',
        shortName: 'Bik55'
    },
    invoices: [
        {
            id: 250,
            agencyId: 21,
            currency: 'USD',
            firstName: 'Bik',
            lastName: '55',
            phone: '8801717416667',
            email: 'bik5@bikiran.com',
            userId: 23,
            organization: 'BIK5',
            invoiceTitle: 'Service Purchase Invoice - BIK5',
            timeIssue: 1761955200,
            timeDue: 1762560000,
            amountBilled: 500,
            amountPaid: 500,
            status: 'paid',
            demo: true
        },
        {
            id: 251,
            agencyId: 21,
            currency: 'USD',
            firstName: 'Bik',
            lastName: '55',
            phone: '8801717416667',
            email: 'bik5@bikiran.com',
            userId: 23,
            organization: 'BIK5',
            invoiceTitle: 'Service Renewal Invoice - BIK5',
            timeIssue: 1764547200,
            timeDue: 1765152000,
            amountBilled: 500,
            amountPaid: 0,
            status: 'pending',
            demo: true
        }
    ],
    transactions: [
        {
            id: 101,
            userId: 23,
            invoiceId: 250,
            method: 'card',
            amount: 500,
            currency: 'USD',
            timeInitiate: 1761955200,
            timeSuccess: 1761958800,
            timeFailed: 0,
            note: 'Payment successful',
            firstName: 'Bik',
            lastName: '55',
            organization: 'BIK5',
            email: 'bik5@bikiran.com',
            phone: '8801717416667',
            status: 'paid',
            customerInfo: null,
            demo: true
        },
        {
            id: 102,
            userId: 23,
            invoiceId: 250,
            method: 'paypal',
            amount: 250,
            currency: 'USD',
            timeInitiate: 1764547200,
            timeSuccess: 0,
            timeFailed: 1764550800,
            note: 'Payment failed - insufficient funds',
            firstName: 'Bik',
            lastName: '55',
            organization: 'BIK5',
            email: 'bik5@bikiran.com',
            phone: '8801717416667',
            status: 'failed',
            customerInfo: null,
            demo: true
        }
    ],
    demo: true
};

export default null;
